<template>
  <el-container :class="['app-shell', { 'sidebar-collapsed': sidebarCollapsed }]">
    <el-aside class="app-sidebar" :width="sidebarCollapsed ? '72px' : '236px'">
      <div class="brand">
        <div class="brand-mark">AI</div>
        <div v-if="!sidebarCollapsed" class="brand-text">
          <strong>Mini New API</strong>
          <a href="https://api.cnm.pink" target="_blank">学习版中转台</a>
        </div>
      </div>
      <el-menu
        :default-active="currentView"
        class="app-menu"
        @select="currentView = $event"
      >
        <el-menu-item index="index">
          <span>首页总览</span>
        </el-menu-item>
        <el-menu-item index="channel">
          <span>渠道管理</span>
        </el-menu-item>
        <el-menu-item index="price">
          <span>模型价格</span>
        </el-menu-item>
        <el-menu-item index="logs">
          <span>请求日志</span>
        </el-menu-item>
        <el-menu-item index="stats">
          <span>数据统计</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header class="app-topbar">
        <el-button class="collapse-button" text @click="sidebarCollapsed = !sidebarCollapsed">
          {{ sidebarCollapsed ? '展开' : '收起' }}
        </el-button>
        <div>
          <span class="topbar-label">API Gateway</span>
          <strong>{{ pageTitle }}</strong>
        </div>
      </el-header>
      <el-main class="app-main">
        <IndexView v-if="currentView === 'index'" />
        <ChannelView v-else-if="currentView === 'channel'" />
        <ModelPriceView v-else-if="currentView === 'price'" />
        <LogView v-else-if="currentView === 'logs'" />
        <StatsView v-else />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import IndexView from './view/index/IndexView.vue'
import ChannelView from './view/channel/ChannelView.vue'
import ModelPriceView from './view/modelPrice/ModelPriceView.vue'
import LogView from './view/log/LogView.vue'
import StatsView from './view/stats/StatsView.vue'
import './styles/base.css'
import './styles/layout.css'
import './styles/components.css'

export default {
  name: 'App',
  components: {
    IndexView,
    ChannelView,
    ModelPriceView,
    LogView,
    StatsView
  },
  data() {
    return {
      currentView: 'index',
      sidebarCollapsed: false
    }
  },
  computed: {
    pageTitle() {
      return {
        index: '首页总览',
        channel: '渠道管理',
        price: '模型价格',
        logs: '请求日志',
        stats: '数据统计'
      }[this.currentView]
    }
  }
}
</script>
